module.exports = __webpack_public_path__ + "static/media/supermarket.b1bbf862.svg";